<mcg-window #listPersonas [loading]="loading()" [title]="titleWindowSignal()" [actions]="actions"
  [containerSelector]="'#map-container'" (actionButtonClicked)="actionButtonClicked($event)"
  (windowClosed)="onClose()"
>
  <app-header #header [exportar]="true" [buscador]="true" [filtro]="true" [resetFiltro]="true"
    (eventExportar)="onExportar()" (eventBuscador)="onBuscar()" (eventFilter)="eventFilter()"
    (eventResetFilter)="eventResetFilter()">
  </app-header>

  <jqxGrid #gridPersonas [theme]="environment.tema" [width]="'100%'" [height]="'calc(100% - 50px)'"
    [source]="sourceGridPersonasAdapter" [localization]="langGrid" [filterable]="true"
    [columns]="columnsGridPersonas" [showrowlines]="false" [columnsresize]="true" [sortable]="true"
    [enablebrowserselection]="true" [altrows]="true" [rowsheight]="25" [columnsheight]="20"
    [groupable]="true" [editable]="false" [updatefilterconditions]="updatefilterconditions"
    (onRowdoubleclick)="onDoubleClick($event.args.rowindex)" (onBindingcomplete)="onBindingComplete()"
    (onFilter)="gridDataUpdate()">
  </jqxGrid>
</mcg-window>

<jqxWindow *ngIf="editando" #formEdit jqxWindowAutoResize [autoOpen]="true" [isModal]="false" [showCloseButton]="true"
  [showCollapseButton]="true" [resizable]="true" [zIndex]="900" (onClose)="onCloseEdit()" (onOpen)="onOpenEdit()"
  (onExpand)="onExpandEdit($event)">
  <div class="formHeader">
    {{translate('Personas')}}
  </div>
  <div class="form" clas="form">
    <div class="row">
      <div class="col1">
        {{translate('Nombre')}}
        <jqxInput #ebNombre [(ngModel)]="personaEdit.nombre" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
      <div class="col2">
        {{translate('Apellidos')}}
        <jqxInput [(ngModel)]="personaEdit.apellidos" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
    </div>
    <div class="row">
      <div class="col1">
        {{translate('Telefono')}}
        <jqxInput [(ngModel)]="personaEdit.telefono" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
      <div class="col2">
        {{translate('Dni')}}
        <jqxInput [(ngModel)]="personaEdit.nif" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
    </div>
    <div class="row">
      <div class="col1">
        {{translate('Identificador')}}
        <jqxInput [(ngModel)]="personaEdit.identificador" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
      <div class="col2">
        {{translate('Email')}}
        <jqxInput [(ngModel)]="personaEdit.email" [width]="'100%'" [height]="25">
        </jqxInput>
      </div>
    </div>
    <div class="row">
      <div class="col1">
        {{translate('Categoria')}}
        <jqxDropDownList #cbCategorias [(ngModel)]="personaEdit.idCategoria" [width]="'100%'" [height]="25"
          [selectedIndex]="0" (onSelect)="onChangeCategoria($event)" [searchMode]="'containsignorecase'"
          [filterable]="true" [filterPlaceHolder]="'Buscar...'">
        </jqxDropDownList>
      </div>
    </div>
    <div class="row-buttons">
      <div class="button1">
        <jqxButton [width]="100" [height]="26" [imgPosition]="'left'" [textImageRelation]="'imageBeforeText'"
          [textPosition]="'left'" [imgSrc]='"/assets/images/save.png"' [value]="translate('Guardar')"
          (onClick)="onGuardar()">
        </jqxButton>
      </div>
      <div class="button2">
        <jqxButton [width]="100" [height]="26" [value]="translate('CANCELAR')" (onClick)="formEdit.close()">
        </jqxButton>
      </div>
    </div>
  </div>
</jqxWindow>
